import { defineMessages } from 'react-intl';

export const messages: {
	a11yAnnouncementItemHidden: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	a11yAnnouncementItemReordered: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	a11yAnnouncementItemUnhidden: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	a11yAnnouncementItemVisible: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	a11yAnnouncementItemHidden: {
		id: 'navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-hidden',
		defaultMessage: 'The top level menu item {label} has been hidden and moved to the More menu.',
		description:
			'Announcement for assistive technology users when a top level menu item is hidden in the global side navigation.',
	},
	a11yAnnouncementItemUnhidden: {
		id: 'navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-unhidden',
		defaultMessage:
			'The top level menu item {label} has been unhidden and moved from the more menu to position {finishIndex}.',
		description:
			'Announcement for assistive technology users when a top level menu item is unhidden in the global side navigation.',
	},
	a11yAnnouncementItemReordered: {
		id: 'navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-reordered',
		defaultMessage:
			'The top level menu item {label} has been moved from position {startIndex} to {finishIndex}.',
		description:
			'Announcement for assistive technology users when a top level menu item is reordered in the global side navigation.',
	},
	a11yAnnouncementItemVisible: {
		id: 'navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-visible',
		defaultMessage:
			'The top level menu item {label} has been moved from the More menu to the visible items.',
		description:
			'Announcement for assistive technology users when a top level menu item is made visible in the global side navigation.',
	},
});
